import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Server filter interface
export interface ServerFilter {
  field: string;
  operator: 'eq' | 'like' | 'in' | 'gt' | 'lt' | 'gte' | 'lte';
  value: string | number | boolean | (string | number)[];
}

// Operator `like` của backend theo đúng ngữ nghĩa SQL LIKE: giá trị phải tự mang
// wildcard. Không có `%`, driver Mongo dịch thành regex `^giá trị$` — tức khớp
// tuyệt đối cả chuỗi, nên ô tìm kiếm gõ một phần tên sẽ không ra gì.
// Bọc `%...%` để `like` luôn là "chứa chuỗi".
function toLikePattern(value: string): string {
  return value.includes('%') ? value : `%${value}%`;
}

// Generic function to convert client filters to server format
export function convertFiltersToServerFormat<T extends Record<string, any>>(
  filters: T,
  fieldMappings: Partial<Record<keyof T, { field: string; operator?: 'eq' | 'like' | 'in' | 'gt' | 'lt' | 'gte' | 'lte' }>>
): ServerFilter[] {
  const serverFilters: ServerFilter[] = [];

  Object.entries(filters).forEach(([key, value]) => {
    if (value && value !== '' && value !== 'all') {
      const mapping = fieldMappings[key as keyof T];
      if (mapping) {
        const operator = mapping.operator || 'eq';
        const trimmed = typeof value === 'string' ? value.trim() : value;

        serverFilters.push({
          field: mapping.field,
          operator,
          value:
            operator === 'like' && typeof trimmed === 'string'
              ? toLikePattern(trimmed)
              : trimmed
        });
      }
    }
  });

  return serverFilters;
}
